import React, { useState } from "react";
import * as Components from "../../../components/all";
import { useParams } from "react-router-dom";

import { AiOutlineUser, AiOutlineCheckCircle } from "react-icons/ai";
import { MdOutlineAlternateEmail, MdPhone } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import { GiModernCity } from "react-icons/gi";
import { FaCarSide } from "react-icons/fa";
import { BsCalendar2Date } from "react-icons/bs";
import { RiParkingBoxLine } from "react-icons/ri";

export default function User() {
	const params = useParams();
	const [loading, setLoading] = useState(false);

	// User Data
	var userData = {
		user: {
			id: 1,
			image:
				"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLe5PABjXc17cjIMOibECLM7ppDwMmiDg6Dw&usqp=CAU",
			name: "Abdul Haseeb",
			email: "abdulhaseeb@gmail.com",
			phone: "0300 9002887",
			address: "Chattha Bakhtawar, Chak Shehzad, Islamabad",
			city: "Islamabad",
			status: "Active",
			created: "24/10/2022",
			cars: [
				{
					number: "RIR 6798",
					name: "Honda Civic",
					model: 2020,
					color: "white",
				},
				{
					number: "RIP 2671",
					name: "Toyota Corolla",
					model: 2021,
					color: "black",
				},
			],
			parkingSpaces: [
				{
					name: "Comsats University, Islamabad",
				},
			],
		},
	};

	// Functions
	const deleteUser = async () => {
		var choice = prompt(
			"Press 'y' if you want to delete the user permanently:"
		);
		if (choice === "y" || choice === "Y") {
		}
	};

	const suspendUser = async () => {
		var choice = prompt("Press 'y' if you want to suspend the user:");
		if (choice === "y" || choice === "Y") {
		}
	};

	const activateUser = async () => {
		var choice = prompt("Press 'y' if you want to active the user:");
		if (choice === "y" || choice === "Y") {
		}
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="User
            overflow-x-hidden overflow-y-auto 
            h-full
            w-full
            sm:p-3 md:p-5
            flex flex-col
            "
		>
			{/* TOP CARDS ROW */}
			<div className="TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[450px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* heading */}
					<div
						className="
							w-full
							p-2 pt-0 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<Components.BackButton />
							<h1 className="ml-2 text-darker">User Data</h1>
						</div>
					</div>

					{/* buttons */}
					<div
						className="
						flex flex-wrap
						items-center justify-end 
						px-2 pb-3
						text-sm
						text-white
						"
					>
						<button
							className={`							mx-2 px-4 py-1 
							${
								userData.user.status.toLowerCase() === "active"
									? "bg-yellow-400"
									: "bg-green-400"
							} 
							font-medium 
							rounded-full
							duration-200 ease-out
							hover:opacity-70
							cursor-pointer`}
							onClick={() => {
								if (userData.user.status.toLowerCase() === "active") {
									suspendUser();
								} else {
									activateUser();
								}
							}}
						>
							{userData.user.status.toLowerCase() === "active"
								? "Suspend"
								: "Activate"}
						</button>

						<button
							className="
							px-4 py-1 
							bg-red-400 
							font-medium 
							rounded-full
							duration-200 ease-out
							hover:opacity-70
							cursor-pointer
							"
							onClick={() => {
								deleteUser();
							}}
						>
							Remove
						</button>
					</div>

					{/* data */}
					<div
						className="
						flex max-md:flex-col justify-center"
					>
						{/* image */}
						<div
							className="
							w-full md:w-[20%] lg:w-[30%]
							min-w-fit
							h-full
							flex md:justify-center
							pr-2 max-md:pb-4
							"
						>
							<div
								className="
								h-40 lg:h-60 
								aspect-square 
								p-4 
								rounded-md border
								"
							>
								<img
									src={userData.user.image}
									alt="user_image"
									className="w-full h-full rounded-md"
								/>
							</div>
						</div>

						{/* info */}
						<div
							className="
							w-full md:w-[70%] lg:w-[60%] 
							flex 
							items-center md:justify-center 
							flex-wrap
							"
						>
							{/* name */}
							<div
								className="
							h-fit
							sm:w-[50%] 
							flex items-center
							p-2
							text-darker 
							overflow-x-auto
							"
							>
								<div
									className="
								h-8 aspect-square
								flex items-center justify-center
								rounded
								text-dark
								border 
								mr-3
								"
								>
									<AiOutlineUser />
								</div>
								{userData.user.name}
							</div>

							{/* email */}
							<div
								className="
							h-fit
							sm:w-[50%] 
							flex items-center
							p-2
							text-darker 
							overflow-x-auto
							"
							>
								<div
									className="
								h-8 aspect-square
								flex items-center justify-center
								rounded
								text-dark
								border 
								mr-3
								"
								>
									<MdOutlineAlternateEmail />
								</div>
								{userData.user.email}
							</div>

							{/* phone */}
							<div
								className="
							h-fit
							sm:w-[50%] 
							flex items-center
							p-2
							text-darker 
							overflow-x-auto
							"
							>
								<div
									className="
								h-8 aspect-square
								flex items-center justify-center
								rounded
								text-dark
								border 
								mr-3
								"
								>
									<MdPhone />
								</div>
								{userData.user.phone}
							</div>

							{/* city */}
							<div
								className="
							h-fit
							sm:w-[50%] 
							flex items-center
							p-2
							text-darker 
							overflow-x-auto
							"
							>
								<div
									className="
								h-8 aspect-square
								flex items-center justify-center
								rounded
								text-dark
								border 
								mr-3
								"
								>
									<GiModernCity />
								</div>
								{userData.user.city}
							</div>

							{/* address */}
							<div
								className="
							h-fit
							sm:w-[50%] 
							flex items-center
							p-2
							text-darker 
							overflow-x-auto
							"
							>
								<div
									className="
								h-8 aspect-square
								flex items-center justify-center
								rounded
								text-dark
								border 
								mr-3
								"
								>
									<IoLocationOutline />
								</div>
								{userData.user.address}
							</div>

							{/* status */}
							<div
								className="
							h-fit
							sm:w-[50%] 
							flex items-center
							p-2
							text-darker 
							overflow-x-auto
							"
							>
								<div
									className="
								h-8 aspect-square
								flex items-center justify-center
								rounded
								text-dark
								border 
								mr-3
								"
								>
									<AiOutlineCheckCircle />
								</div>
								{userData.user.status}
							</div>

							{/* created */}
							<div
								className="
							h-fit
							sm:w-[100%] 
							flex items-center
							p-2
							text-darker 
							overflow-x-auto
							"
							>
								<div
									className="
								h-8 aspect-square
								flex items-center justify-center
								rounded
								text-dark
								border 
								mr-3
								"
								>
									<BsCalendar2Date />
								</div>
								{userData.user.created}
							</div>

							{/* cars */}
							<div
								className="
							h-fit
							sm:w-[100%] 
							flex flex-col
							p-2
							text-darker 
							overflow-x-auto
							"
							>
								<div className="flex items-center">
									<div
										className="
								h-8 aspect-square
								flex items-center justify-center
								rounded
								text-dark
								border 
								mr-3
								"
									>
										<FaCarSide />
									</div>
									<div>Registered Cars</div>
								</div>
								<div className="w-full pl-9 flex max-md:flex-col">
									{userData.user.cars.map((car) => (
										<div
											className="
										flex flex-col 
										border rounded-md
										m-2
										"
										>
											<div
												className="
											flex 
											items-center 
											text-sm px-2 py-1
											"
											>
												<h1
													className="
												text-xs 
												uppercase
												w-[60px]
												"
												>
													Number:
												</h1>
												<h1 className="uppercase">{car.number}</h1>
											</div>

											<div
												className="
											flex 
											items-center 
											text-sm px-2 py-1
											"
											>
												<h1
													className="
												text-xs 
												uppercase
												w-[60px]
												"
												>
													Name:
												</h1>
												<h1 className="capitalize">{car.name}</h1>
											</div>

											<div
												className="
											flex 
											items-center 
											text-sm px-2 py-1
											"
											>
												<h1
													className="
												text-xs 
												uppercase
												w-[60px]
												"
												>
													Model:
												</h1>
												<h1 className="capitalize">{car.model}</h1>
											</div>

											<div
												className="
											flex 
											items-center 
											text-sm px-2 py-1
											"
											>
												<h1
													className="
												text-xs 
												uppercase
												w-[60px]
												"
												>
													Color:
												</h1>
												<h1 className="capitalize">{car.color}</h1>
											</div>
										</div>
									))}
								</div>
							</div>

							{/* parking spaces */}
							<div
								className="
							h-fit
							sm:w-[100%] 
							flex flex-col
							p-2
							text-darker 
							overflow-x-auto
							"
							>
								<div className="flex items-center">
									<div
										className="
								h-8 aspect-square
								flex items-center justify-center
								rounded
								text-dark
								border 
								mr-3
								"
									>
										<RiParkingBoxLine />
									</div>
									<div>Parking Spaces</div>
								</div>
								<div className="w-full pl-9 flex">
									{userData.user.parkingSpaces.map((ps) => (
										<div
											className="
										flex flex-col 
										border rounded-md
										m-2
										"
										>
											<h1 className="uppercase px-2 py-1">{ps.name}</h1>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
